import { EventEmitter } from '@angular/core';
import { CartTableLineComponent } from '../../components/cart-table-line';
import { ApiOrder } from '../../../cart/models/cart-models';
import { Store, select } from '@ngrx/store';
import * as fromAuth from '../../../auth/reducers';
import { BackorderCounts } from '../../models/backorder-counts';
var CartTableComponent = /** @class */ (function () {
    function CartTableComponent(store) {
        this.store = store;
        this.LineComponent = CartTableLineComponent;
        this.backordercounts = {};
        this.onLineChange = new EventEmitter();
        this.onLineDelete = new EventEmitter();
        this.onDetails = new EventEmitter();
        this.tenantName$ = store
            .pipe(select(fromAuth.getCurrentTenantName));
    }
    Object.defineProperty(CartTableComponent.prototype, "orderDiscount", {
        get: function () {
            return this.order.discount && this.order.discount + ' %';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableComponent.prototype, "orderSubTotal", {
        get: function () {
            // Backwards compatible fix when order.subTotalPrice is not available
            if (!this.order.subTotalPrice) {
                return this.order.totalPrice;
            }
            else {
                return this.order.subTotalPrice;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableComponent.prototype, "orderTotal", {
        get: function () {
            return this.order.totalPrice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableComponent.prototype, "lines", {
        get: function () {
            return this.order.lines;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableComponent.prototype, "footerSpan", {
        get: function () {
            return this.editable
                ? 9
                : 7;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableComponent.prototype, "showLineDiscount", {
        get: function () {
            return this.discountType === 'linedisc';
        },
        enumerable: true,
        configurable: true
    });
    CartTableComponent.prototype.openDetails = function (product) {
        this.onDetails.emit(product);
    };
    CartTableComponent.prototype.changeLine = function ($event) {
        this.onLineChange.emit($event);
    };
    CartTableComponent.prototype.deleteLine = function ($event) {
        this.onLineDelete.emit($event);
    };
    CartTableComponent.prototype.isLineInBackorder = function (line) {
        var productBackorderCount = this.backordercounts[line.product.code] || 0;
        return productBackorderCount > 0;
    };
    Object.defineProperty(CartTableComponent.prototype, "quantityPickerRelative", {
        get: function () {
            return (this.quantityPicker && this.quantityPicker.toLowerCase() === 'relative');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableComponent.prototype, "showUomValues", {
        get: function () {
            return this.showUomInfoForUoms && this.showUomInfoForUoms.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CartTableComponent.prototype, "showExtraCosts", {
        get: function () {
            return this.extraCosts && this.extraCosts.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    CartTableComponent.prototype.getUomValueForUom = function (uom) {
        if (this.order.quantitiesInUom && this.order.quantitiesInUom.length > 0) {
            var uomValue = this.order.quantitiesInUom.find(function (uomValue) { return uomValue.key === uom; });
            if (uomValue) {
                return uomValue.value;
            }
        }
        return 0;
    };
    return CartTableComponent;
}());
export { CartTableComponent };
